"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// @endindex
// @index('./*', pp => `import * as ${pp.name} from '${pp.path}';`, { "ignore": ["./*.ts", "./*.md"] })
var InputMappingItem = require("./InputMappingItem");
exports.InputMappingItem = InputMappingItem;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@kurtosys/ksys-app-template/dist/models/configuration/index.js
// module id = 768
// module chunks = 1